// extracted by mini-css-extract-plugin
module.exports = {"container":"PageModal_container__WxE0R","title":"PageModal_title__wOMdF","compressed":"PageModal_compressed__21Nlh","error-message":"PageModal_error-message__k9O9S"};